import { render } from "./SVGShelf.vue?vue&type=template&id=39435877"
import script from "./SVGShelf.vue?vue&type=script&lang=js"
export * from "./SVGShelf.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__